export default "__VITE_ASSET__DnEy3jXP__"